import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
// import List from '@material-ui/core/List';
// import ListItem from '@material-ui/core/ListItem';
// import ListItemIcon from '@material-ui/core/ListItemIcon';
// // import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
// import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Chip from '@material-ui/core/Chip';
import Button from '@material-ui/core/Button';
import RefreshIcon from '@material-ui/icons/Refresh';
import CircularProgress from '@material-ui/core/CircularProgress';
import moment from 'moment';
import { asyncListAll, request } from 'utilities/graph';
import {
  getElder,
  getDeliveryStaff,
  getRestaurant,
  listDeliveryStaffs,
  getDeliveryStaffsByCountyByIsActive,
  listElders,
  getEldersByCountyByCreatedAt,
  getOrdersByDeliveryStaffByDate,
  getOrdersByCountyByDate,
  getOrdersByStatusByDate,
  getElderDeliveryGroupsByClientByStatus,
  getOrdersByRestaurantByDate,
  listRestaurants,
  getRestaurantsByCountyByIsActive,
  getElderServiceEventsByElderByStartedAt,
} from 'graphql/queries';
import { getOrdersByElderByDate } from 'components/Schedule/queries';
import { counties, TIME_ZONE, elderServiceEventOptions } from '@silvergatedelivery/constants';
import { sortBy, sortOrdersByDeliveryGroups, sortOrder } from 'utilities/sorting';
import ScheduleCalendar from 'components/Schedule/ScheduleCalendar';
import OrderStatusChip from 'components/OrderStatusChip';
import AdminOrderEditButton from 'forms/AdminOrderForm/AdminOrderEditButton';
import cache from 'utilities/cache';
import { getTranslatedOrderStatus, getTranslatedMealSlots } from 'utilities/translate';
import ElderServiceEventDialog from 'components/ElderServiceSchedule/ElderServiceEventDialog';
import DeleteElderServiceEventDialog from 'components/ElderServiceSchedule/DeleteElderServiceEventDialog';
import ElderLeaveAndMedicalDialog from 'components/ElderServiceSchedule/ElderLeaveAndMedicalDialog';
import ElderReminderDialog from 'components/ElderServiceSchedule/ElderReminderDialog';
import ElderStopServiceDialog from 'components/ElderServiceSchedule/ElderStopServiceDialog';
import TextField from '@material-ui/core/TextField';
import { toastr } from 'react-redux-toastr';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

const useStyles = makeStyles((theme) => ({
  container: {
    flex: 1,
    backgroundColor: '#fff',
  },
  content: {
    padding: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
  },
}));

const DATE_FORMAT = 'YYYY-MM-DD';

const getDates = (from, to) => {
  const dates = [moment(to).tz(TIME_ZONE).format(DATE_FORMAT)];

  while (dates[0] > from) {
    const prev = moment(dates[0]).tz(TIME_ZONE).add(-1, 'day').format(DATE_FORMAT);
    dates.unshift(prev);
  }
  return dates;
};

export default function Schedule({
  deliveryStaffId,
  elderId,
  clientId: inClientId,
  restaurantId,
  defaultLocations = [cache.get('app:location')].filter((x) => x),
  defaultOrderStatus = [
    'waitingForDeliveryStaff',
    'reMatchingDeliveryStaff',
    'ready',
    'readyForPickup',
    'delivering',
    'delivered',
    'completed',
  ],
  showLocationSelector = true,
  showDeliverStaffSelector = true,
  showElderSelector = true,
  showRestaurantSelector = true,
}) {
  const classes = useStyles();
  const { t } = useTranslation();

  const getTargetOrderStatus = () => cache.get('app:admin:schedule:targetOrderStatus') || defaultOrderStatus;
  const [isLoading, setIsLoading] = useState(false);
  const [lastUpdatedAt, setLastUpdatedAt] = useState(Date.now());
  const [targetOrderStatus, setTargetOrderStatus] = useState(getTargetOrderStatus);
  const [targetCounties, setTargetCounties] = useState(defaultLocations);
  const [targetDeliveryStaffIds, setTargetDeliveryStaffIds] = useState([]);
  const [targetElderIds, setTargetElderIds] = useState([]);
  const [targetMealSlots, setTargetMealSlots] = useState(['lunch', 'dinner']);
  const [targetRestaurantIds, setTargetRestaurantIds] = useState([]);

  // const [allOrders, setAllOrders] = useState([]);
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [deliveryStaffOptions, setDeliveryStaffOptions] = useState([]);
  const [elderOptions, setElderOptions] = useState([]);
  const [restaurantOptions, setRestaurantOptions] = useState([]);
  const [dateInfo, setDateInfo] = useState();
  const [orderMappings, setOrderMappings] = useState({});
  const [elderServiceEvents, setElderServiceEvents] = useState([]);
  const [elderServiceEventId, setElderServiceEventId] = useState();
  const [openSelectionMenu, setOpenSelectionMenu] = useState(false);
  const [selectedDateRange, setSelectedDateRange] = useState(null);
  const [openLeaveAndMedicalDialog, setOpenLeaveAndMedicalDialog] = useState(false);
  const [openReminderDialog, setOpenReminderDialog] = useState(false);
  const [openStopServiceDialog, setOpenStopServiceDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deletingEvent, setDeletingEvent] = useState(null);
  const [currentEventType, setCurrentEventType] = useState('leave');
  const [editingEvent, setEditingEvent] = useState(null);

  const onDateChange = (newDateInfo) => {
    const newFromDate = moment(newDateInfo.startStr).tz(TIME_ZONE).format(DATE_FORMAT);
    const newToDate = moment(newDateInfo.endStr).tz(TIME_ZONE).format(DATE_FORMAT);

    const { fromDate, toDate } = dateInfo || {};

    if (newFromDate !== fromDate || newToDate !== toDate) {
      setDateInfo({
        fromDate: newFromDate,
        toDate: newToDate,
        dates: getDates(newFromDate, newToDate),
      });
    }
  };

  useEffect(() => {
    if (!dateInfo) return;

    (async () => {
      if (elderId && targetElderIds.length === 0) return;
      if (deliveryStaffId && targetDeliveryStaffIds.length === 0) return;

      setIsLoading(true);

      let orders = [];
      const { dates } = dateInfo;
      const clientId = cache.get('app:facilityId') || inClientId;
      let elderDeliveryGroups;

      global.logger.debug('Fetching orders', dateInfo);

      const queryPromises = [];

      const asyncListAllWrapper = async (queryName, params) => {
        const key = JSON.stringify(params);

        if (orderMappings[key]) {
          // global.logger.debug(`${key} exists, use cache data`);
          return orderMappings[key];
        }

        const data = await asyncListAll(queryName, params);
        orderMappings[key] = data;

        setOrderMappings({ ...orderMappings });

        return data;
      };

      if (elderId && targetElderIds[0]) {
        targetElderIds.forEach((elderId) => {
          dates.forEach((date) => {
            queryPromises.push(asyncListAllWrapper(getOrdersByElderByDate, {
              elderId,
              date: {
                eq: date,
              },
            }));
          });
        });
      } else
      if (deliveryStaffId && targetDeliveryStaffIds[0]) {
        const clientFilter = clientId ? {
          clientId: {
            eq: clientId,
          },
        } : null;
        targetDeliveryStaffIds.forEach((deliveryStaffId) => {
          dates.forEach((date) => {
            queryPromises.push(asyncListAllWrapper(getOrdersByDeliveryStaffByDate, {
              deliveryStaffId,
              date: {
                eq: date,
              },
              filter: clientFilter,
            }));
          });
        });
        if (clientId) {
          elderDeliveryGroups = await asyncListAll(getElderDeliveryGroupsByClientByStatus, {
            clientId: clientId,
            status: { eq: '使用中' },
            limit: 1000,
          });
        }
      } else
      if (restaurantId && targetRestaurantIds[0]) {
        const clientFilter = clientId ? {
          clientId: {
            eq: clientId,
          },
        } : null;
        targetRestaurantIds.forEach((restaurantId) => {
          dates.forEach((date) => {
            queryPromises.push(asyncListAllWrapper(getOrdersByRestaurantByDate, {
              restaurantId,
              date: {
                eq: date,
              },
              filter: clientFilter,
            }));
          });
        });
      } else
      if (targetCounties.length > 0) {
        targetCounties.forEach((county) => {
          dates.forEach((date) => {
            queryPromises.push(asyncListAllWrapper(getOrdersByCountyByDate, {
              county,
              date: {
                eq: date,
              },
            }));
          });
        });
      } else
      if (targetOrderStatus.length > 0) {
        targetOrderStatus.forEach((status) => {
          dates.forEach((date) => {
            queryPromises.push(asyncListAllWrapper(getOrdersByStatusByDate, {
              status,
              date: {
                eq: date,
              },
            }));
          });
        });
      }

      const results = await Promise.all(queryPromises);
      results.forEach((items) => {
        if (elderDeliveryGroups) {
          const sortedItems = sortOrdersByDeliveryGroups(items, elderDeliveryGroups);
          orders = [...orders, ...sortedItems];
        } else {
          orders = [...orders, ...items.sort(sortOrder)];
        }
      });

      setOrders(orders);

      setIsLoading(false);
    })();
  }, [
    lastUpdatedAt,
    targetCounties,
    targetOrderStatus,
    targetDeliveryStaffIds,
    targetElderIds,
    elderId,
    deliveryStaffId,
    dateInfo,
  ]);

  useEffect(() => {
    const filteredOrders = orders
      .filter((item) => {
        let shouldRender = true;
        if (targetCounties.length > 0 && !targetCounties.includes(item.county)) {
          shouldRender = false;
        }
        if (targetOrderStatus.length > 0 && !targetOrderStatus.includes(item.status)) {
          shouldRender = false;
        }
        if (targetMealSlots.length > 0 && !targetMealSlots.includes(item.mealSlot)) {
          shouldRender = false;
        }
        if (targetDeliveryStaffIds.length > 0 && !targetDeliveryStaffIds.includes(item.deliveryStaffId)) {
          shouldRender = false;
        }
        if (targetElderIds.length > 0 && !targetElderIds.includes(item.elderId)) {
          shouldRender = false;
        }
        if (targetRestaurantIds.length > 0 && !targetRestaurantIds.includes(item.restaurantId)) {
          shouldRender = false;
        }
        return shouldRender;
      });

    global.logger.debug('orders', { orders, filteredOrders });

    setFilteredOrders(filteredOrders);
  }, [orders, targetCounties, targetOrderStatus, targetMealSlots, targetElderIds, targetDeliveryStaffIds, targetRestaurantIds]);

  useEffect(() => {
    if (!showElderSelector) {
      if (elderId) {
        setTargetElderIds([elderId]);
      }
      return;
    }
    (async () => {
      let elders = [];
      if (elderId) {
        const { data: { getElder: data } } = await request(getElder, { id: elderId });
        elders = [data];
      } else
      if (targetCounties.length === 0) {
        elders = await asyncListAll(listElders);
      } else {
        await Promise.all(targetCounties.map(async (county) => {
          const data = await asyncListAll(getEldersByCountyByCreatedAt, {
            county,
          });
          elders = [...elders, ...data];
        }));
      }

      global.logger.debug('elders', elders);

      setElderOptions([
        ...elders.map(({ id, name }) => {
          return {
            label: name,
            value: id,
          };
        }).sort(sortBy('label'))]);

      if (elderId) {
        setTargetElderIds([elderId]);
      }
    })();
  }, [targetCounties, elderId, showElderSelector]);

  useEffect(() => {
    if (!showDeliverStaffSelector) {
      if (deliveryStaffId) {
        setTargetDeliveryStaffIds([deliveryStaffId]);
      }
      return;
    }

    (async () => {
      let deliveryStaffs = [];
      if (deliveryStaffId) {
        const { data: { getDeliveryStaff: data } } = await request(getDeliveryStaff, { id: deliveryStaffId });
        deliveryStaffs = [data];
      } else
      if (targetCounties.length === 0) {
        deliveryStaffs = await asyncListAll(listDeliveryStaffs);
      } else {
        await Promise.all(targetCounties.map(async (county) => {
          const data = await asyncListAll(getDeliveryStaffsByCountyByIsActive, {
            county,
            isActive: { eq: 1 },
          });
          deliveryStaffs = [...deliveryStaffs, ...data];
        }));
      }

      setDeliveryStaffOptions([
        { label: '尚無指派', value: null },
        ...deliveryStaffs.map(({ id, name }) => {
          return {
            label: name,
            value: id,
          };
        }).sort(sortBy('label'))]);

      if (deliveryStaffId) {
        setTargetDeliveryStaffIds([deliveryStaffId]);
      }
    })();
  }, [targetCounties, deliveryStaffId, showDeliverStaffSelector]);

  useEffect(() => {
    if (!showRestaurantSelector) {
      if (restaurantId) {
        setTargetRestaurantIds([restaurantId]);
      }
      return;
    }
    (async () => {
      let restaurants = [];
      if (restaurantId) {
        const { data: { getRestaurant: data } } = await request(getRestaurant, { id: restaurantId });
        restaurants = [data];
      } else
      if (targetCounties.length === 0) {
        restaurants = await asyncListAll(listRestaurants);
      } else {
        await Promise.all(targetCounties.map(async (county) => {
          const data = await asyncListAll(getRestaurantsByCountyByIsActive, {
            county,
            isActive: { eq: 1 },
          });
          restaurants = [...restaurants, ...data];
        }));
      }
      setRestaurantOptions([
        ...restaurants.map(({ id, name }) => ({
          label: name,
          value: id,
        })).sort(sortBy('label')),
      ]);
      if (restaurantId) {
        setTargetRestaurantIds([restaurantId]);
      }
    })();
  }, [targetCounties, restaurantId, showRestaurantSelector]);

  useEffect(() => {
    if (!elderId || !dateInfo) return;
    (async () => {
      setIsLoading(true);
      const { fromDate, toDate } = dateInfo;
      const start = moment(fromDate).tz(TIME_ZONE).toISOString();
      const end = moment(toDate).tz(TIME_ZONE).toISOString();
      const [eventsWithEndedAt, eventsWithoutEndedAt] = await Promise.all([
        asyncListAll(getElderServiceEventsByElderByStartedAt, {
          elderId,
          startedAt: { lt: end },
          filter: {
            and: [
              { status: { ne: '已刪除' } },
              { endedAt: { gt: start } },
            ],
          },
        }),
        asyncListAll(getElderServiceEventsByElderByStartedAt, {
          elderId,
          startedAt: { between: [start, end] },
          filter: {
            and: [
              { status: { ne: '已刪除' } },
              { or: [{ type: { eq: 'reminder' } }, { type: { eq: 'serviceStop' } }] },
            ],
          },
        }),
      ]);
      setElderServiceEvents([...eventsWithEndedAt, ...eventsWithoutEndedAt]);
      setIsLoading(false);
    })();
  }, [elderId, dateInfo, lastUpdatedAt]);

  const renderChipValue = (selected) => (
    <div className={classes.chips}>
      {selected.map((value, index) => {
        return (<Chip
          key={index}
          label={value}
          // className={classes.chip}
          // style={{ color, backgroundColor }}
        />);
      })}
    </div>
  );

  const renderDeliveryStaffChipValue = (selected) => (
    <div className={classes.chips}>
      {selected.map((value, index) => {
        return (<Chip
          key={index}
          label={deliveryStaffOptions.find((item)=>item.value === value).label}
        />);
      })}
    </div>
  );

  const renderElderChipValue = (selected) => (
    <div className={classes.chips}>
      {selected.map((value, index) => {
        return (<Chip
          key={index}
          label={elderOptions.find((item)=>item.value === value).label}
        />);
      })}
    </div>
  );

  const renderStatusChipValue = (selected) => (
    <div className={classes.chips}>
      {selected.map((value) => {
        return (<OrderStatusChip status={value} key={value} />);
      })}
    </div>
  );
  const translatedMealSlots = getTranslatedMealSlots();
  const renderMealSlotValue = (selected) => (
    <div className={classes.chips}>
      {selected.map((value, index) => {
        return (<Chip
          key={index}
          label={translatedMealSlots.find((item)=>item.value === value).label}
        />);
      })}
    </div>
  );

  const renderRestaurantChipValue = (selected) => (
    <div className={classes.chips}>
      {selected.map((value, index) => {
        return (<Chip
          key={index}
          label={restaurantOptions.find((item)=>item.value === value).label}
        />);
      })}
    </div>
  );

  const handleEventClick = (event) => {
    if (event.elderServiceEventId) {
      setElderServiceEventId(event.elderServiceEventId);
    }
  };
  const handleDateSelection = (dateRange) => {
    setSelectedDateRange(dateRange);
    setOpenSelectionMenu(true);
  };
  const handleMenuOptionClick = (option) => {
    if (selectedDateRange) {
      const start = selectedDateRange.start;
      const end = selectedDateRange.end;
      if (!start || !end || isNaN(new Date(start).getTime()) || isNaN(new Date(end).getTime())) {
        toastr.error('日期錯誤', '請選擇有效的起始日與結束日');
        return;
      }
      if (start > end) {
        toastr.error('日期錯誤', '起始日不可晚於結束日');
        return;
      }
    }
    if (option.id === 'leave' || option.id === 'medical') {
      setCurrentEventType(option.id);
      setOpenLeaveAndMedicalDialog(true);
    } else if (option.id === 'reminder') {
      setOpenReminderDialog(true);
    } else if (option.id === 'serviceStop') {
      setOpenStopServiceDialog(true);
    }
    setOpenSelectionMenu(false);
  };
  const handleCloseSelectionMenu = () => {
    setOpenSelectionMenu(false);
    setSelectedDateRange(null);
  };
  const handleEditEvent = (event) => {
    setEditingEvent(event);
    setElderServiceEventId(null);
    if (event.type === 'leave' || event.type === 'medical') {
      setCurrentEventType(event.type);
      setSelectedDateRange({
        start: event.startedAt,
        end: event.endedAt || moment(event.startedAt).add(1, 'day').toDate(),
        startStr: moment(event.startedAt).format('YYYY-MM-DD'),
        endStr: event.endedAt ? moment(event.endedAt).format('YYYY-MM-DD') : moment(event.startedAt).add(1, 'day').format('YYYY-MM-DD'),
      });
      setOpenLeaveAndMedicalDialog(true);
    } else if (event.type === 'reminder') {
      setSelectedDateRange({
        start: event.startedAt,
        end: moment(event.startedAt).add(1, 'day').toDate(),
        startStr: moment(event.startedAt).format('YYYY-MM-DD'),
        endStr: moment(event.startedAt).add(1, 'day').format('YYYY-MM-DD'),
      });
      setOpenReminderDialog(true);
    } else if (event.type === 'serviceStop') {
      setSelectedDateRange({
        start: event.startedAt,
        end: moment(event.startedAt).add(1, 'day').toDate(),
        startStr: moment(event.startedAt).format('YYYY-MM-DD'),
        endStr: moment(event.startedAt).add(1, 'day').format('YYYY-MM-DD'),
      });
      setOpenStopServiceDialog(true);
    }
  };
  const handleDeleteEvent = (event) => {
    setDeletingEvent(event);
    setElderServiceEventId(null);
    setOpenDeleteDialog(true);
  };
  const handleRefresh = () => {
    setOrderMappings({});
    setLastUpdatedAt(Date.now());
  };

  return (
    <div className={classes.container}>
      <Grid container>
        <Grid container item md={2} className={classes.content} direction="column">
          {showLocationSelector &&
            <FormControl className={classes.formControl}>
              <InputLabel id="mutiple-counties-label">縣市</InputLabel>
              <Select
                labelId="mutiple-counties-label"
                id="mutiple-counties"
                multiple
                value={targetCounties}
                onChange={(event) => setTargetCounties(event.target.value)}
                input={<Input id="select-multiple-counties" />}
                renderValue={renderChipValue}
                disabled={isLoading}
              >
                {counties.map((item) => (
                  <MenuItem key={item} value={item}>
                    <Checkbox checked={targetCounties.indexOf(item) > -1} />
                    {item}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>}
          <FormControl className={classes.formControl}>
            <InputLabel id="mutiple-orderStatus-label">狀態</InputLabel>
            <Select
              labelId="mutiple-orderStatus-label"
              id="mutiple-orderStatus"
              multiple
              value={targetOrderStatus}
              onChange={(event) => {
                cache.set('app:admin:schedule:targetOrderStatus', event.target.value);
                setTargetOrderStatus(event.target.value);
              }}
              input={<Input id="select-multiple-orderStatus" />}
              renderValue={renderStatusChipValue}
              disabled={isLoading}
            >
              {getTranslatedOrderStatus().map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  <Checkbox checked={targetOrderStatus.indexOf(item.value) > -1} />
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl className={classes.formControl}>
            <InputLabel id="mutiple-mealSlot-label">{`${t('午餐')}/${t('晚餐')}`}</InputLabel>
            <Select
              labelId="mutiple-mealSlot-label"
              id="mutiple-mealSlot"
              multiple
              value={targetMealSlots}
              onChange={(event) => setTargetMealSlots(event.target.value)}
              input={<Input id="select-multiple-mealSlot" />}
              renderValue={renderMealSlotValue}
              disabled={isLoading}
            >
              {translatedMealSlots.map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  <Checkbox checked={targetMealSlots.indexOf(item.value) > -1} />
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {showDeliverStaffSelector &&
          <FormControl className={classes.formControl}>
            <InputLabel id="mutiple-deliveryStaffIds-label">{t('送餐大使')}</InputLabel>
            <Select
              labelId="mutiple-deliveryStaffIds-label"
              id="mutiple-deliveryStaffIds"
              multiple
              value={targetDeliveryStaffIds}
              onChange={(event) => setTargetDeliveryStaffIds(event.target.value)}
              input={<Input id="select-multiple-deliveryStaffIds" />}
              renderValue={renderDeliveryStaffChipValue}
              disabled={isLoading}
            >
              {deliveryStaffOptions.map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  <Checkbox checked={targetDeliveryStaffIds.indexOf(item.value) > -1} />
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>}
          {showElderSelector &&
            <FormControl className={classes.formControl}>
              <InputLabel id="mutiple-elderIds-label">{t('送餐對象')}</InputLabel>
              <Select
                labelId="mutiple-elderIds-label"
                id="mutiple-elderIds"
                multiple
                value={targetElderIds}
                onChange={(event) => setTargetElderIds(event.target.value)}
                input={<Input id="select-multiple-elderIds" />}
                renderValue={renderElderChipValue}
                disabled={isLoading}
              >
                {elderOptions.map((item) => (
                  <MenuItem key={item.value} value={item.value}>
                    <Checkbox checked={targetElderIds.indexOf(item.value) > -1} />
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>}
          {showRestaurantSelector &&
            <FormControl className={classes.formControl}>
              <InputLabel id="mutiple-restaurantIds-label">{t('餐廳')}</InputLabel>
              <Select
                labelId="mutiple-restaurantIds-label"
                id="mutiple-restaurantIds"
                multiple
                value={targetRestaurantIds}
                onChange={(event) => setTargetRestaurantIds(event.target.value)}
                input={<Input id="select-multiple-restaurantIds" />}
                renderValue={renderRestaurantChipValue}
                disabled={isLoading}
              >
                {restaurantOptions.map((item) => (
                  <MenuItem key={item.value} value={item.value}>
                    <Checkbox checked={targetRestaurantIds.indexOf(item.value) > -1} />
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>}
          <Button
            onClick={handleRefresh}
            disabled={isLoading}
          >
            {!isLoading &&
            <React.Fragment>
              <RefreshIcon fontSize="small" />
              重新整理
            </React.Fragment>}
            {isLoading && <CircularProgress color="primary" size={16} />}
          </Button>
          <AdminOrderEditButton
            mode="create"
            type="button"
            onUpdate={() => {
              setOrderMappings({});
              setLastUpdatedAt(Date.now());
            }}
            disabled={isLoading}
          />
        </Grid>
        <Grid item xs={12} md={10} className={classes.content}>
          <ScheduleCalendar
            orders={filteredOrders}
            elderServiceEvents={elderId ? elderServiceEvents : undefined}
            onDateChange={onDateChange}
            onDateSelection={elderId ? handleDateSelection : undefined}
            onEventClick={elderId ? handleEventClick : undefined}
            showElderName={!elderId}
          />
        </Grid>
      </Grid>
      {/* Dialogs for service events */}
      {elderId && (
        <>
          {elderServiceEventId && (
            <ElderServiceEventDialog
              id={elderServiceEventId}
              open={true}
              onClose={() => setElderServiceEventId(null)}
              onEdit={handleEditEvent}
              onDelete={handleDeleteEvent}
            />
          )}
          <DeleteElderServiceEventDialog
            open={openDeleteDialog}
            onClose={() => {
              setOpenDeleteDialog(false);
              setDeletingEvent(null);
            }}
            event={deletingEvent}
            onSuccess={handleRefresh}
          />
          <ElderLeaveAndMedicalDialog
            open={openLeaveAndMedicalDialog}
            onClose={() => {
              setOpenLeaveAndMedicalDialog(false);
              setSelectedDateRange(null);
              setEditingEvent(null);
            }}
            clientId={cache.get('app:facilityId') || inClientId}
            elderId={elderId}
            dateRange={selectedDateRange}
            onSuccess={handleRefresh}
            orders={orders}
            eventType={currentEventType}
            editingEvent={editingEvent}
          />
          <ElderReminderDialog
            open={openReminderDialog}
            onClose={() => {
              setOpenReminderDialog(false);
              setSelectedDateRange(null);
              setEditingEvent(null);
            }}
            clientId={cache.get('app:facilityId') || inClientId}
            elderId={elderId}
            dateRange={selectedDateRange}
            onSuccess={handleRefresh}
            editingEvent={editingEvent}
          />
          <ElderStopServiceDialog
            open={openStopServiceDialog}
            onClose={() => {
              setOpenStopServiceDialog(false);
              setSelectedDateRange(null);
              setEditingEvent(null);
            }}
            clientId={cache.get('app:facilityId') || inClientId}
            elderId={elderId}
            dateRange={selectedDateRange}
            onSuccess={handleRefresh}
            editingEvent={editingEvent}
          />
          <Dialog
            open={openSelectionMenu}
            onClose={handleCloseSelectionMenu}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle>
              選擇事項類型
              {selectedDateRange && (
                <>
                  <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
                    <TextField
                      label="起始日"
                      type="date"
                      size="small"
                      variant="outlined"
                      value={moment(selectedDateRange.start).format('YYYY-MM-DD')}
                      onChange={(e) => {
                        const newStart = moment(e.target.value).toDate();
                        setSelectedDateRange((range) => ({ ...range, start: newStart, startStr: e.target.value }));
                      }}
                      InputLabelProps={{ shrink: true }}
                      style={{ minWidth: 120 }}
                    />
                    <TextField
                      label="結束日"
                      type="date"
                      size="small"
                      variant="outlined"
                      value={moment(selectedDateRange.end).subtract(1, 'day').format('YYYY-MM-DD')}
                      onChange={(e) => {
                        const newEnd = moment(e.target.value).add(1, 'day').toDate();
                        const newEndStr = moment(e.target.value).add(1, 'day').format('YYYY-MM-DD');
                        setSelectedDateRange((range) => ({ ...range, end: newEnd, endStr: newEndStr }));
                      }}
                      InputLabelProps={{ shrink: true }}
                      style={{ minWidth: 120 }}
                    />
                  </div>
                </>
              )}
            </DialogTitle>
            <DialogContent>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 16, padding: 16 }}>
                {elderServiceEventOptions.map((option) => {
                  const IconComponent = option.icon;
                  return (
                    <MenuItem
                      key={option.id}
                      onClick={() => handleMenuOptionClick(option)}
                      style={{
                        border: `2px solid ${option.color}`,
                        borderRadius: 8,
                        margin: 4,
                        padding: 16,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        minHeight: 80,
                      }}
                    >
                      <ListItemIcon style={{ color: option.color, minWidth: 'auto' }}>
                        <IconComponent style={{ fontSize: 32 }} />
                      </ListItemIcon>
                      <ListItemText
                        primary={option.label}
                        style={{ textAlign: 'center', marginTop: 8 }}
                      />
                    </MenuItem>
                  );
                })}
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseSelectionMenu} color="default">
                取消
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )}
    </div>
  );
}


Schedule.propTypes = {
  elderId: PropTypes.string,
  clientId: PropTypes.string,
  deliveryStaffId: PropTypes.string,
  restaurantId: PropTypes.string,
  defaultLocations: PropTypes.array,
  defaultOrderStatus: PropTypes.array,
  showLocationSelector: PropTypes.bool,
  showElderSelector: PropTypes.bool,
  showDeliverStaffSelector: PropTypes.bool,
  showRestaurantSelector: PropTypes.bool,
};
